module.exports = __webpack_public_path__ + "static/media/financial icon 2.d63f6235.png";